import { strings as stringManager } from '../../Strings';
export const moduleName = 'rangePenetrationCard';
stringManager.load(moduleName, {
    blurb: 'How far into the job\'s range has their pay progressed?',
    cardTitle: 'Range Penetration',
    max: 'Max',
    min: 'Min'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
